import { useEffect, useRef, useState } from 'react';
import Loader from '../../common/Loader';
import { useFetchTournamentData } from '../../data/useFetchTournamentData';
import { getPrincipaleOPrimoGruppo, hideTooltip } from '../../data/utils';
import PrematchTournamentMatchContainer from './PrematchTournamentMatchContainer';

export default function PrematchTournament(props) {
    const tournamentData = props.tournament;
    const [tournament, setTournament] = useState(null);
    const primaAggregata = getPrincipaleOPrimoGruppo(tournamentData.aggregate).idAggregata;
    const [aggregata, setAggregata] = useState(primaAggregata);
    const [aggregataFetch, setAggregataFetch] = useState(primaAggregata);
    const [macrogruppo, setMacrogruppo] = useState(null);
    const [reload, setReload] = useState(false);
    
    const [search, setSearch] = useState(null);
    function handleChange(event) {
        setSearch(event.target.value);
    }

    function handleReload() {
        setTournament(null);
        setReload(reload => !reload);
    }

    useEffect(() => {
        window.addEventListener('reload-all-tournaments', handleReload);
        return () => {
            window.removeEventListener('reload-all-tournaments', handleReload);
            hideTooltip();
        };
    }, []);

    // Force data reload when the prop forceReload changes, unless it's the first render
    const firstRender = useRef(true);
    useEffect(function() {
        if (firstRender.current) {
            firstRender.current = false;
        } else {
            handleReload();
        }
    }, [props.forceReload]);

    function changeMacrogruppo(mg) {
        if (macrogruppo == null || (mg.id !== macrogruppo.id)) {
            setMacrogruppo(mg);
            setAggregataFetch(mg.aggregate[0].idAggregata);
        }
    }

    function changeAggregata(ag) {
        if (ag !== aggregata) {
            setAggregataFetch(ag);
        }
    }

    const [request] = useFetchTournamentData(props.data, tournamentData, aggregataFetch, true, reload);
    useEffect(function() {
        if (!request.isLoading && !request.isError) {
            setTournament(request.data);
            setAggregata(aggregataFetch);
        }
    }, [request, aggregataFetch]);

    const Header = props.header;

    return (
        <Header tournament={props.tournament}
                data={tournament}
                toggled={props.toggled}
                handleReload={handleReload}
                handleChange={handleChange}
        >
            {tournament == null ?
                <Loader error={request.isError} />
                :
                <PrematchTournamentMatchContainer
                    data={props.data}
                    tournament={tournament}
                    macrogruppo={macrogruppo}
                    changeMacrogruppo={changeMacrogruppo}
                    aggregata={aggregata}
                    changeAggregata={changeAggregata}
                    openFromPath={props.openFromPath}
                    filter={search} />
            }
        </Header>
    );
}
